<template>
  <v-stepper v-model="itemActive" vertical non-linear class="tabsStepper">
    <v-layout wrap align-start justify-start fill-height row>
      <v-flex class="tabs ">
        <v-text-field v-model="searchText" solo-inverted hide-details clearable
                      prepend-inner-icon="search" label="Buscar equipo" class="small-control square my-0 py-0"
        />

        <v-stepper-step v-for="equipo in equiposSearch" :key="equipo.NumeroOrden" :step="equipo.NumeroOrden" editable>
          <div class="equipo-descripcion">
            <span class="subheading">
              {{ equipo.NombreNetBios }}
            </span>
            <span v-if="equipo.Descripcion" class="body-1">
              {{ equipo.Descripcion }}
            </span>
          </div>
          <span v-if="equipo.DireccionIp" class="body-1">
            Ip: {{ equipo.DireccionIp }}
          </span>
        </v-stepper-step>
      </v-flex>

      <v-flex class="items " style="overflow-y: auto;">
        <v-stepper-content v-for="equipo in equiposSearch" :key="equipo.NumeroOrden" :step="equipo.NumeroOrden">
          <v-card :class="classSteep">
            <copy-chip :text="equipo.DireccionIp" class="subheading ml-0 mb-3" />
            <v-tabs v-if="!!firstTab(equipo)"
                    show-arrows dark color="primary" slider-color="orange" class="mb-5 elevation-2"
            >
              <v-tab v-if="equipo.ConexionVnc">
                Vnc
              </v-tab>
              <v-tab v-if="equipo.ConexionLogMeIn">
                Supremo
              </v-tab>
              <v-tab v-if="equipo.ConexionMySql">
                MySql
              </v-tab>
              <v-tab v-if="equipo.ConexionTerminalServer">
                TerminalServer
              </v-tab>
              <v-tab v-if="equipo.ConexionRemoteAnything">
                RemoteAnything
              </v-tab>
              <v-tab v-if="equipo.ConexionFtp">
                Ftp
              </v-tab>
              <v-tab v-if="equipo.ConexionTheos">
                Theos
              </v-tab>
              <v-tab v-if="equipo.ConexionVPNClient">
                VPNClient
              </v-tab>

              <v-tab-item v-if="equipo.ConexionVnc">
                <v-card flat>
                  <v-card-text>
                    Puerto Vnc: <strong>{{ equipo.PuertoVnc }}</strong> <br>
                    Contraseña Vnc: <strong>{{ equipo.ContraenaVnc }}</strong> <br>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item v-if="equipo.ConexionLogMeIn">
                <v-card flat>
                  <v-card-text>
                    <strong class="ml-1">
                      {{ equipo.UsuarioLogMeIn }}
                    </strong><br>
                    <copy-chip :text="equipo.ContrasenaLogMeIn" class="subheading" />
                    <v-btn :href="`supremo:${equipo.UsuarioLogMeIn.replace(/ /g, '')}`" target="_parent"
                           color="green" fab dark icon class="btn-dense" @click="sleepAskToLeave"
                    >
                      <v-icon dark>
                        mdi-remote-desktop
                      </v-icon>
                    </v-btn>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item v-if="equipo.ConexionMySql">
                <v-card flat>
                  <v-card-text>
                    Puerto MySql: <strong>{{ equipo.PuertoMySql }}</strong> <br>
                    Usuario MySql: <strong>{{ equipo.UsuarioMySql }}</strong> <br>
                    Contraseña MySql: <strong>{{ equipo.ContrasenaMySql }}</strong> <br>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item v-if="equipo.ConexionTerminalServer">
                <v-card flat>
                  <v-card-text>
                    Puerto TerminalServer: <strong>{{ equipo.PuertoTerminalServer }}</strong> <br>
                    Usuario TerminalServer: <strong>{{ equipo.UsuarioTerminalServer }}</strong> <br>
                    Contraseña TerminalServer: <copy-chip :text="equipo.ContrasenaTerminalServer" class="subheading" />
                    <!-- <v-btn :href="`rdp://full%20address=${equipo.DireccionIp}:mypc:${equipo.PuertoTerminalServer}`"
                             color="green" fab dark icon small>
                        <v-icon dark>mdi-remote-desktop</v-icon>
                      </v-btn> -->
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item v-if="equipo.ConexionRemoteAnything">
                <v-card flat>
                  <v-card-text>
                    Puerto RemoteAnything: <strong>{{ equipo.PuertoRemoteAnything }}</strong> <br>
                    Contraseña RemoteAnything: <strong>{{ equipo.ContraenaRemoteAnything }}</strong> <br>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item v-if="equipo.ConexionFtp">
                <v-card flat>
                  <v-card-text>
                    Usuario Ftp: <strong>{{ equipo.UsuarioFtp }}</strong> <br>
                    Contraseña Ftp: <strong>{{ equipo.ContrasenaFtp }}</strong> <br>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item v-if="equipo.ConexionTheos">
                <v-card flat>
                  <v-card-text>
                    Usuario Theos: <strong>{{ equipo.UsuarioTheos }}</strong> <br>
                    Contraseña Theos: <strong>{{ equipo.ContrasenaTheos }}</strong> <br>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item v-if="equipo.ConexionVPNClient">
                <v-card flat>
                  <v-card-text>
                    Usuario VPNClient: <strong>{{ equipo.UsuarioVPNClient }}</strong> <br>
                    Contraseña VPNClient: <strong>{{ equipo.ContrasenaVPNClient }}</strong> <br>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
            <div class="description mb-4">
              <!-- SistemaOperativo: {{ equipo.SistemaOperativo }} <br><br> -->
              <span v-html="equipo.Observaciones" />
            </div>
          </v-card>
        </v-stepper-content>
      </v-flex>

      <inner-loading :visible="loading" />
    </v-layout>
  </v-stepper>
</template>

<script>
import InnerLoading from '@/components/InnerLoading'
import CopyChip from '@/components/CopyChip'
import { Entities } from 'mixins/index.js'

export default {
  name: 'Equipos',
  components: { CopyChip, InnerLoading },
  mixins: [ Entities ],
  props: {
    cliente: {
      type: [String, Number],
      default: '0'
    },
    instalacion: {
      type: [String, Number],
      default: '0'
    }
  },
  data () {
    return {
      loading: false,
      classSteep: 'pa-3 back',
      equipos: [],
      tabActive: null,
      itemActive: 'n',
      searchText: null
    }
  },
  computed: {
    equiposSearch () {
      if (this.searchText) {
        let text = this.searchText.toLowerCase()
        return this.equipos.filter(obj => {
          return (obj.NombreNetBios && obj.NombreNetBios.toLowerCase().includes(text)) ||
           (obj.Descripcion && obj.Descripcion.toLowerCase().includes(text)) ||
            (obj.DireccionIp && obj.DireccionIp.toLowerCase().includes(text))
        })
      } else return this.equipos
    }
  },
  methods: {
    sleepAskToLeave () {
      let AskToLeave = this.$store.state.askToLeave
      this.$store.dispatch('AskToLeave', false)
      setTimeout(() => {
        this.$store.dispatch('AskToLeave', AskToLeave)
      }, 750)
    },
    firstTab (equipo) {
      return equipo.ConexionVnc || equipo.ConexionLogMeIn || equipo.ConexionMySql ||
                      equipo.ConexionTerminalServer || equipo.ConexionRemoteAnything || equipo.ConexionFtp ||
                      equipo.ConexionTheos || equipo.ConexionVPNClient
    },
    clearn () {
      this.equipos = []
    },
    load (cliente, instalacion) {
      this.equipos = []
      if (cliente && instalacion) {
        this.loading = true
        this.itemActive = 'x'
        this.axios.get(`${this.$apiUrl('instalacionEquipo')}?cliente=${cliente}&instalacion=${instalacion}`,
          { headers: { 'Content-Type': 'application/json' } })
          .then(({ data }) => {
            if (data) {
              this.equipos = data
              this.$nextTick(() => {
                this.itemActive = this.equipos[0].NumeroOrden
              })
            }
          })
          .catch(() => { })
          .then(() => { this.loading = false })
      }
    }
  }
}
</script>
